/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChardiOverviewDto } from '../../models/chardi-overview-dto';

export interface ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Params {
  chargerId?: string;
  connectorId?: number;
}

export function apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain(http: HttpClient, rootUrl: string, params?: ApiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ChardiOverviewDto>> {
  const rb = new RequestBuilder(rootUrl, apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain.PATH, 'get');
  if (params) {
    rb.query('chargerId', params.chargerId, {});
    rb.query('connectorId', params.connectorId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChardiOverviewDto>;
    })
  );
}

apiParkingPlaceGetParkingPlaceByChargerIdAndConnectorIdGet$Plain.PATH = '/api/ParkingPlace/GetParkingPlaceByChargerIdAndConnectorId';
